<template>
  <div ref="container" tabindex="-1" class="messages__no_chats">
    <template v-if="type === 'member'">
      <h2 class="messages__no_chats__header">
        {{ i18n.$gettext('You are not a member yet') }}
      </h2>
      <p class="messages__no_chats__paragraph">
        {{ i18n.$gettext('Become a member of a project and connect with the people behind it.') }}
      </p>
      <div class="messages__no_chats__action">
        <a :href="discoverPath" class="btn btn--primary">
          {{ i18n.$gettext('Discover projects') }}
        </a>
      </div>
    </template>
    <template v-if="type === 'publisher'">
      <img
        class="messages__no_chats__image"
        src="https://assets.steadyhq.com/gfx/backend/astronaut.png?auto=format&w=150"
        srcset="
          https://assets.steadyhq.com/gfx/backend/astronaut.png?auto=format&w=150       1x,
          https://assets.steadyhq.com/gfx/backend/astronaut.png?auto=format&w=150&dpr=2 2x
        "
        alt=""
        aria-hidden="true"
        width="150"
        height="193"
      />
      <h2 class="messages__no_chats__header">
        {{ i18n.$gettext('Something is missing') }}
      </h2>
      <p class="messages__no_chats__paragraph">
        {{
          i18n.$gettext(
            "Your publication doesn't have any members yet. Check out our Help Centre for tips on getting your first members."
          )
        }}
      </p>
      <div class="messages__no_chats__action">
        <a :href="helpCenterURL" class="btn btn--primary">
          {{ i18n.$gettext('Help Centre') }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { CHAT_LIST_HASH } from './route_helpers'
import focusOnRouteChange from './focus_on_route_change'

export default {
  name: 'NoChats',
  mixins: [focusOnRouteChange('container', CHAT_LIST_HASH)],
  props: {
    discoverPath: { type: String, required: true },
    helpCenterURL: { type: String, required: true },
    type: {
      required: true,
      validator: function (value) {
        return ['member', 'publisher'].indexOf(value) !== -1
      }
    }
  }
}
</script>
